import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--argument-category"
export default class extends Controller {
  static targets = ["input", "output"]

  connect() {
    this.performFilter(this.inputTarget.value)
  }

  performFilter(value) {
    this.outputTarget.querySelectorAll("option[data-parent-id]").forEach((e)=>{
      if (e.dataset.parentId == value) {
        e.disabled = null;
      } else {
        e.disabled = "disabled";
      } 
    });
  }

  filter(e) {
    this.performFilter(e.target.value)
  }
}
